<template>
  <footer class="footer">
    <!-- 主要内容区域 -->
    <div class="footer-main">
      <div class="container">
        <div class="footer-content">
          <!-- 服务概览 -->
          <div class="footer-section">
            <h5 class="footer-title">服务概览</h5>
            <ul class="footer-links">
              <li><a href="#">网站建设</a></li>
              <li><a href="#">网页设计</a></li>
              <li><a href="#">移动应用</a></li>
            </ul>
          </div>

          <!-- 成功案例 -->
          <div class="footer-section">
            <h5 class="footer-title">成功案例</h5>
            <ul class="footer-links">
              <li><a href="#">桌面网站</a></li>
              <li><a href="#">移动网站</a></li>
              <li><a href="#">科研网站</a></li>
              <li><a href="#">软件应用</a></li>
            </ul>
          </div>

          <!-- 公司动态 -->
          <div class="footer-section">
            <h5 class="footer-title">公司动态</h5>
            <ul class="footer-links">
              <li><a href="#">信息公开</a></li>
              <li><a href="#">最近新闻</a></li>
              <li><a href="#">最新博客</a></li>
            </ul>
          </div>

          <!-- 帮助与支持 -->
          <div class="footer-section">
            <h5 class="footer-title">帮助与支持</h5>
            <ul class="footer-links">
              <li><a href="#">帮助中心</a></li>
              <li><a href="#">联系客服</a></li>
              <li><a href="#">文档资源</a></li>
            </ul>
          </div>

          <!-- 联系我们 -->
          <div class="footer-section contact-info-section">
            <h5 class="footer-title">联系我们</h5>
            <p>地址: 中国(山东)自由贸易试验区烟台片区</p>
            <p>万寿山路5号内1号楼5051室</p>
            <p>电话: 15853501426</p>
            <p>电子邮件: wequst@163.com</p>
          </div>

          <!-- 微信公众号 -->
          <div class="footer-section qrcode-section">
            <h5 class="footer-title">关注我们</h5>
            <div class="qrcode-wrapper">
              <img src="../../assets/OfficialAccount.jpg" alt="微信公众号" class="qrcode-img" />
              <p class="qrcode-text">微信公众号</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部备案信息 -->
    <div class="footer-bottom">
      <div class="container">
        <div class="beian-info">
          <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">
            鲁ICP备2022042007号-1
          </a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37069302000964" 
             target="_blank" class="beian-link">
            <img src="../../assets/beian.png" alt="备案图标" class="beian-icon"/>
            鲁公网安备 37069302000964号
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
.footer {
  background-color: #1a1a1a; // Dark background
  color: #ffffff; // White text
  padding-top: 60px;
  font-size: 14px;
  line-height: 1.8;
}

.footer-main {
  padding-bottom: 40px;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); // Adjust minmax for column width
  gap: 30px; // Gap between columns
  justify-content: space-between; // Distribute columns
}

.footer-section {
  margin-bottom: 20px;
}

.footer-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #ffffff;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 8px;
  }

  a {
    color: #ffffff;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #cccccc; // Slightly lighter on hover
    }
  }
}

.contact-info-section {
  p {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.qrcode-section {
  text-align: center;
}

.qrcode-wrapper {
  display: inline-block;
  
  .qrcode-img {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    background: #fff;
    padding: 5px;
    margin-bottom: 10px;
  }
  
  .qrcode-text {
    font-size: 13px;
    color: #aaa;
    margin: 0;
  }
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1); // Subtle separator line
  padding: 20px 0;
  text-align: center;
  font-size: 12px;
  color: #aaaaaa; // Slightly lighter grey for bottom text
}

.beian-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px; // 增加间距到20px

  .beian-link {
    color: #ffffff; // 白色字体
    text-decoration: none; // 去掉下划线
    font-size: 12px;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 5px;
    
    &:hover {
      color: #cccccc; // 悬停时稍微变灰
    }
  }

  .beian-icon {
    width: 16px; // Adjust size as needed
    height: 16px;
    vertical-align: middle;
  }
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    justify-content: center;
    text-align: center;
  }
  .footer-section {
    margin-bottom: 30px;
  }
  .footer-title {
    margin-bottom: 10px;
  }
  .footer-links li {
    margin-bottom: 5px;
  }
  .contact-info-section {
    p {
      margin-bottom: 5px;
    }
  }
}

@media (max-width: 480px) {
  .footer-content {
    grid-template-columns: 1fr; // Single column on very small screens
    text-align: center;
  }
  .footer-section {
    margin-bottom: 25px;
  }
  .footer-main {
    padding-bottom: 30px;
  }
  .footer-bottom {
    padding: 15px 0;
  }
  .copyright-info {
    flex-direction: column;
    gap: 5px;
  }
}
</style>